import { render, staticRenderFns } from "./ClientData.vue?vue&type=template&id=b887d1ea"
import script from "./ClientData.vue?vue&type=script&lang=js"
export * from "./ClientData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports